import { z } from "zod/v4"
import { UserId } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"

export const RecommendedUserDocumentMeta = z.object({
  user_id: z.string().describe("おすすめするユーザーのID"),
})

export type RecommendedUserDocumentMeta = z.infer<typeof RecommendedUserDocumentMeta>

export const RecommendedUserDocumentBody = RecommendedUserDocumentMeta.extend({
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type RecommendedUserDocumentBody = z.infer<typeof RecommendedUserDocumentBody>

export type RecommendedUserDocument = RecommendedUserDocumentBody & {
  id: UserId
}

export class RecommendedUserDocuments {
  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): RecommendedUserDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: UserId(doc.id),
      user_id: data["user_id"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export const CreateRecommendedUserRequest = z.object({
  userId: z.string(),
})

export type CreateRecommendedUserRequest = z.infer<typeof CreateRecommendedUserRequest>
